import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useFileUpload } from '@wix/da-shared-react/pkg/utils/hooks/useFileUpload';
import { IMAGE_MIME } from '@wix/da-shared-react/pkg/utils/mime';
import Loader from '@wix/da-ds/pkg/Loader/Loader';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton/GhostButton';

import s from './CoverImageField.scss';

interface Props {}

const CoverImageField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { input, getDropzoneRootProps, isDragging } = useFileUpload({
    id: 'custom-exclusive-cover-image',
    allowMultiple: false,
    allowDragAndDrop: false,
    acceptedMimeTypes: IMAGE_MIME,
    // onDrop: () => true,
  });

  return (
    <div
      className={cn(s['root'], isDragging && s['drag-active'])}
      {...getDropzoneRootProps()}
    >
      {input}
      <Loader className={s['llama']} size="big" state="eating_grass" />
      <span className={s['title']}>
        {t('customExclusivePopup.form.coverImage.title')}
      </span>
      <span className={s['text']}>
        {t('customExclusivePopup.form.coverImage.subtitle')}
      </span>
      <GhostButton className={s['add-btn']} variant="main" size="large">
        {t('customExclusivePopup.form.coverImage.btn')}
      </GhostButton>
    </div>
  );
};
CoverImageField.displayName = 'CoverImageField';

export default CoverImageField;
